// Dynamically import a specific MDX file
export async function importMdx(locale, path) {
  return await import( /* webpackChunkName: "[request]" */
  `./${locale}/${path}.mdx`);
}